import {Component, computed, input, output, OutputEmitterRef, Signal} from '@angular/core';

import {translate, TranslocoPipe} from '@jsverse/transloco';
import {AbstractSidePanelComponent} from '../../../../shared/ui/side-panel/abstract-side-panel.component';
import {SidePanelGridComponent} from '../../../../shared/ui/side-panel-grid/side-panel-grid.component';
import {InquiryTopicButtonComponent} from '../inquiry-topic-button/inquiry-topic-button.component';
import {PageId} from '../../enum/inquiry-page.enum';
import {Topic} from '../../enum/topic.enum';
import {InquiryQuestion} from '../../data-access/interface/inquiry.interface';

@Component({
  selector: 'cov-inquiry-intro',
  imports: [TranslocoPipe, SidePanelGridComponent, InquiryTopicButtonComponent],
  templateUrl: './inquiry-intro.component.html',
  styleUrl: './inquiry-intro.component.scss',
})
export class InquiryIntroComponent extends AbstractSidePanelComponent {
  // INPUT
  public orderNumber = input<string | null>(null);
  public itemNumber = input<string | null | undefined>(null);

  // OUTPUT
  public changePage: OutputEmitterRef<InquiryQuestion> = output();

  // STATE
  protected orderKnown = computed(() => {
    const id = this.orderNumber();
    const itemNumber = this.itemNumber();
    return (id?.length ?? 0) > 0 || (itemNumber?.length ?? 0) > 0;
  });

  protected topics: Signal<InquiryQuestion[]> = computed(() => {
    if (this.orderKnown()) {
      return [
        {
          question: translate(
            'inquiries.sideDrawer.home.questions.knownOrderNumber.orderNumberItemNumber',
            {
              orderNumber: this.orderNumber(),
              itemNumber: this.itemNumber(),
            },
          ),
          topic: Topic.ORDER_FROM_CONTEXT,
          destination: PageId.INQUIRY_FORM,
        },
        {
          question: translate(
            'inquiries.sideDrawer.home.questions.knownOrderNumber.differentOrderNumber',
          ),
          topic: Topic.SPECIFIC_ORDER,
          destination: PageId.ORDER_SELECT,
        },
        {
          question: translate(
            'inquiries.sideDrawer.home.questions.knownOrderNumber.generalQuestion',
          ),
          topic: Topic.GENERAL_INQUIRY,
          destination: PageId.INQUIRY_FORM,
        },
      ];
    }

    return [
      {
        question: translate('inquiries.sideDrawer.home.questions.unknownOrderNumber.specificOrder'),
        destination: PageId.ORDER_SELECT,
        topic: Topic.SPECIFIC_ORDER,
      },
      {
        question: translate(
          'inquiries.sideDrawer.home.questions.unknownOrderNumber.generalQuestion',
        ),
        topic: Topic.GENERAL_INQUIRY,
        destination: PageId.INQUIRY_FORM,
      },
    ];
  });
}
